import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoUnsubscribeService implements OnDestroy {  
  protected readonly destroy$ = new Subject<void>();
  private _componentName = '(unknown)';

  setComponentName(name: string) {
    this._componentName = name;
  }

  ngOnDestroy(): void {
    console.log('AutoUnsubscribe '+ this._componentName + ' intiated...')
    this.destroy$.next();
    this.destroy$.complete();
  }
}
